/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'

import CollapseContext from 'contexts/CollapseContext'
import { v4 as uuidv4 } from 'uuid'

const defaultCollapseSettings = {
  updatedOnce: false,
  edit: false,
  expand: true,
}

const useCollapse = () => {
  const context = React.useContext(CollapseContext)

  if (context === undefined) {
    throw new Error(
      'useCollapse must be used within a CollapseContext.Provider',
    )
  }

  const get = collapseId => {
    return context.data.find(item => item.collapseId === collapseId)
  }

  const add = item => {
    context.setData(data => [
      ...data,
      {
        ...item,
        collapseId: uuidv4(),
        collapseSettings: {
          ...defaultCollapseSettings,
          ...item.collapseSettings,
        },
      },
    ])
  }

  const addMultiple = items => {
    items.forEach(item => add(item))
  }

  const remove = collapseId => {
    context.setData(data => data.filter(item => item.collapseId !== collapseId))
  }

  const update = (collapseId, updatedData) => {
    context.setData(data =>
      data.map(item => {
        if (item.collapseId !== collapseId) {
          return item
        }

        return {
          ...item,
          ...updatedData,
          collapseSettings: {
            ...item.collapseSettings,
            ...updatedData.collapseSettings,
            updatedOnce: true,
          },
        }
      }),
    )
  }

  const reset = () => {
    context.setData([])
  }

  const toggleEdit = collapseId => {
    context.setData(data =>
      data.map(item => {
        if (item.collapseId !== collapseId) {
          return item
        }

        return {
          ...item,
          collapseSettings: {
            ...item.collapseSettings,
            edit: !item.collapseSettings.edit,
          },
        }
      }),
    )
  }

  const setExpand = (collapseId, expand) => {
    context.setData(data =>
      data.map(item => {
        if (item.collapseId !== collapseId) {
          return item
        }

        return {
          ...item,
          collapseSettings: {
            ...item.collapseSettings,
            expand,
          },
        }
      }),
    )
  }

  const setUpdatedOnce = (collapseId, updatedOnce) => {
    context.setData(data =>
      data.map(item => {
        if (item.collapseId !== collapseId) {
          return item
        }

        return {
          ...item,
          collapseSettings: {
            ...item.collapseSettings,
            updatedOnce,
          },
        }
      }),
    )
  }

  return {
    data: context.data,
    setData: context.setData,

    get,
    add,
    addMultiple,
    update,
    remove,
    reset,
    setExpand,
    toggleEdit,
    setUpdatedOnce,
  }
}

export default useCollapse
